import apibase from './BaseAPI';

const search = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/search', params)
        return res.data

    } catch (err) {
        throw err
    }

}

const save = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/save', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const update = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/update', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getById = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/getById', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getByRoomId = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/getByRoomId', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getByEmail = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/getByEmail', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getByHash = async (hashKey) => {
    try {
        const res = await apibase.post('/activeTenant/getByHash', hashKey)
        return res.data

    } catch (err) {
        throw err
    }
}

const getTRPendingCount = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/getTRPendingCount', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const downloadActiveTenantList = async (params) => {
    try {
        const res = await apibase.post('activeTenant/downloadActiveTenantList', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const quickSearchActiveRoom = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/quickSearchActiveRoom', params)
        return res.data

    } catch (err) {
        throw err
    }

}

const quickSearchActiveTenant = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/quickSearchActiveTenant', params)
        return res.data

    } catch (err) {
        throw err
    }

}

const checkout = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/checkout', params)
        return res.data

    } catch (err) {
        throw err
    }

}

const saveTenancyRenewal = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/saveTenancyRenewal', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const updateTenancyRenewal = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/updateTenancyRenewal', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const renewRequestCount = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/renewRequestCount', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const endDateCount = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/endDateCount', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const scheduleCheckOutDate = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/scheduleCheckOutDate', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const checkUpcomingRecord = async (params) => {
    try {
        const res = await apibase.post('/activeTenant/checkUpcomingRecord', params)
        return res.data

    } catch (err) {
        throw err
    }
}


export default {
    search: search,
    save: save,
    update: update,
    getById: getById,
    getByRoomId: getByRoomId,
    getByEmail: getByEmail,
    getByHash: getByHash,
    getTRPendingCount: getTRPendingCount,
    downloadActiveTenantList: downloadActiveTenantList,
    quickSearchActiveRoom: quickSearchActiveRoom,
    quickSearchActiveTenant: quickSearchActiveTenant,
    checkout: checkout,
    saveTenancyRenewal: saveTenancyRenewal,
    updateTenancyRenewal: updateTenancyRenewal,
    renewRequestCount: renewRequestCount,
    endDateCount: endDateCount,
    scheduleCheckOutDate: scheduleCheckOutDate,
    checkUpcomingRecord: checkUpcomingRecord
}